import styled from "styled-components";
import { useAppSelector } from "../app/hooks";
import { scheduleState, } from "../app/reducers/schedule-slice";
import DashboardInfo from "../components/board/DashboardInfo";
import { DeliveryGroupDialog } from "../components/dialog/DeliveryGroupDialog";
import DashboardMap from "../components/map/DashboardMap";

const DashboardView = () => {
    const { selectedStatus, selectedClientIds } =
        useAppSelector(scheduleState);

    return (
        <DashBoardContainer>
            <DashboardMap
                selectedStatus={selectedStatus}
                selectedClientIds={selectedClientIds}
            />
            <DashboardInfo
                selectedStatus={selectedStatus}
                selectedClientIds={selectedClientIds}
            />
            <DeliveryGroupDialog />
        </DashBoardContainer>
    );
};

const DashBoardContainer = styled.div`
  width: fit-content;
  overflow: scroll;
`;

export default DashboardView;
